import { httpClient } from '@/services/client/http-client'
import {
  CreatorCampaignApiItem,
  CreatorCampaignDetailApiItem,
  FocCampaignRegistrationApiItem,
} from '@/types/campaign'

export const __cCreatorCampaignService = {
  getCreatorCampaigns: async () => {
    const { data } = await httpClient.V4.get<{
      data: readonly CreatorCampaignApiItem[]
    }>('/foc-campaigns')
    return data ?? []
  },

  getCreatorCampaignDetail: async (slug: string) => {
    const { data } = await httpClient.V4.get<{
      data: CreatorCampaignDetailApiItem
    }>(`/foc-campaigns/${slug}`)
    return data
  },

  getMyRegistrations: async () => {
    const { data } = await httpClient.V4.get<{
      data: readonly FocCampaignRegistrationApiItem[]
    }>('/foc-campaigns/me/registrations')
    return data ?? []
  },
}
